import { useHistory } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { ButtonLink, Flexer } from '@scouts/ui'

import { PATH_RESET_PASSWORD, PATH_SIGNUP } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return (
        <Flexer column gap="12px" alignCenter>
            <ButtonLink onClick={() => history.push(PATH_RESET_PASSWORD)}>
                ¿Has olvidado tu contraseña? Restáurala
            </ButtonLink>

            <ButtonLink onClick={() => history.push(PATH_SIGNUP)}>¿No tienes cuenta? Regístrate</ButtonLink>
        </Flexer>
    )
}

export const Login = () => {
    return (
        <Auth.LockscreenLayout title="Inicia sesión" footer={<Footer />}>
            <Auth.LoginForm />
        </Auth.LockscreenLayout>
    )
}
